import { keepPreviousData, useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { useParams } from 'react-router';

import { apiClient } from '../api-client.ts';
import type { ReceiptBaseDto } from '../types';

export type ReceiptsFilters = {
  party?: string;
  status?: string;
  assigned?: string;
  itemSearch?: string;
  dateFrom?: Date;
  dateTo?: Date;
};

export const useReceipts = (filters: ReceiptsFilters = {}) => {
  const { projectId } = useParams();

  return useQuery<ReceiptBaseDto[]>({
    queryKey: ['receipts', projectId, filters],
    queryFn: () =>
      apiClient.get(`/v1/projects/${projectId}/receipts`, {
        params: {
          ...filters,
          dateFrom: filters.dateFrom
            ? dayjs(filters.dateFrom).startOf('day').toISOString()
            : undefined,
          dateTo: filters.dateTo ? dayjs(filters.dateTo).endOf('day').toISOString() : undefined,
        },
      }),
    placeholderData: keepPreviousData,
    enabled: !!projectId,
  });
};
